import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-762197fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full overflow-hidden rounded-lg" }
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = ["d"]
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm font-normal text-[#68688D]"
}
const _hoisted_8 = ["d"]
const _hoisted_9 = {
  key: 0,
  "data-testid": "dropdown-card-body",
  class: "overflow-hidden bg-white"
}
const _hoisted_10 = { class: "flex flex-col gap-y-4 border-t border-lightGray30 p-4" }

import { ref } from 'vue'
import { mdiChevronUp } from '@mdi/js'

type ApprovalStatusOption = 'approved' | 'rejected' | null


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownCard',
  props: {
    title: {},
    icon: { default: undefined },
    approvalStatus: { default: undefined },
    subtitle: { default: undefined },
    startOpen: { type: Boolean, default: false },
    testId: { default: undefined }
  },
  setup(__props: any) {

const props = __props;



// CONTRATO INVERTIDO (intencional, documentado em DropdownCard.stories.ts):
// startOpen=false → isOpen=true → inicia ABERTO. startOpen=true → inicia FECHADO.
const isOpen = ref(!props.startOpen)

const toggle = () => {
  isOpen.value = !isOpen.value
}

const enter = (element: Element) => {
  const el = element as HTMLElement
  el.style.height = 'auto'
  const height = getComputedStyle(el).height
  el.style.height = '0'
  getComputedStyle(el)
  setTimeout(() => {
    el.style.height = height
  })
}

const afterEnter = (element: Element) => {
  const el = element as HTMLElement
  el.style.height = 'auto'
}

const leave = (element: Element) => {
  const el = element as HTMLElement
  el.style.height = getComputedStyle(el).height
  getComputedStyle(el)
  setTimeout(() => {
    el.style.height = '0'
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: toggle,
      "data-testid": _ctx.testId,
      class: _normalizeClass(["flex w-full items-center justify-between p-4 text-left", {
        'bg-[#F7DAE2] text-neutral50': props.approvalStatus === 'approved',
        'bg-white text-neutral50': props.approvalStatus !== 'approved'
      }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        (props.icon)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 0,
              "data-testid": "dropdown-card-icon",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              class: _normalizeClass(["h-5 w-5 shrink-0", {
            'text-neutralLight':
              props.approvalStatus === null || props.approvalStatus === undefined,
            'text-negative': props.approvalStatus === 'approved',
            'text-neutral50': props.approvalStatus === 'rejected'
          }])
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: props.icon,
                "clip-rule": "evenodd"
              }, null, 8, _hoisted_4)
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1),
          (props.subtitle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.subtitle), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        class: _normalizeClass(["h-6 w-6 shrink-0 transform transition-transform duration-300", { 'rotate-180': !isOpen.value }])
      }, [
        _createElementVNode("path", { d: _unref(mdiChevronUp) }, null, 8, _hoisted_8)
      ], 2))
    ], 10, _hoisted_2),
    _createVNode(_Transition, {
      name: "expand",
      onEnter: enter,
      onAfterEnter: afterEnter,
      onLeave: leave
    }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})